import React from "react";
import { ArrowUpRight, BookOpen, Heart, MessageCircle } from "lucide-react";
import useReveal from "@/hooks/useReveal";

const WHATSAPP_URL =
  "https://wa.me/5581981739909?text=" +
  encodeURIComponent(
    "Olá! Cheguei pelo site e gostaria de conversar."
  );

export default function FinalCTA() {
  const r = useReveal();
  return (
    <section
      id="cta-final"
      data-testid="final-cta-section"
      className="relative section-pad bg-[#0B1E36] text-white overflow-hidden"
    >
      <div className="absolute inset-0 bg-noise" aria-hidden />
      <div
        className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(197,160,89,0.18) 0%, transparent 70%)" }}
        aria-hidden
      />
      <div className="relative max-w-5xl mx-auto px-6 md:px-8 text-center">
        <div ref={r} className="reveal">
          <span className="text-[0.72rem] uppercase tracking-[0.3em] text-[#C5A059] font-medium">
            Convite
          </span>
          <h2 className="mt-6 font-serif-display text-[3rem] sm:text-5xl md:text-6xl lg:text-[5.5rem] leading-[0.98] tracking-[-0.032em] font-medium">
            Você não chegou aqui
            <br />
            <span className="italic text-[#C5A059]">por acaso</span>.
          </h2>
          <p className="mt-12 max-w-2xl mx-auto text-[1.15rem] md:text-[1.3rem] text-white/70 leading-[1.82] font-light">
            Existe um propósito sendo construído, e você pode fazer parte
            dele. Acompanhe o conteúdo diário, leia os e-books e apoie o
            Instituto. A transformação começa por dentro e se estende para o
            mundo.
          </p>
          <div className="mt-12 flex flex-wrap items-center justify-center gap-4">
            <a
              href="/palavra-de-hoje"
              data-testid="final-cta-devotional"
              className="btn-primary-gold"
            >
              <BookOpen size={16} strokeWidth={1.5} />
              Acessar conteúdos
            </a>
            <a
              href="/livros"
              data-testid="final-cta-books"
              className="btn-ghost-light"
            >
              <Heart size={16} strokeWidth={1.5} />
              Adquirir livros
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="final-cta-whatsapp"
              className="btn-ghost-light"
            >
              <MessageCircle size={16} strokeWidth={1.5} />
              Falar no WhatsApp
              <ArrowUpRight size={14} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
